import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { colors } from '../../styles/colors';
import { pickLocaleText } from '../../utils/publicPagesDefaults';

const severityStyles = {
  info: {
    bg: 'rgba(66, 165, 245, 0.15)',
    border: colors.secondaryBlue,
    labelKey: 'publicPages.banners.severityInfo'
  },
  warning: {
    bg: 'rgba(243, 156, 18, 0.18)',
    border: colors.warning,
    labelKey: 'publicPages.banners.severityWarning'
  },
  error: {
    bg: 'rgba(231, 76, 60, 0.18)',
    border: colors.error,
    labelKey: 'publicPages.banners.severityError'
  }
};

const Banner = styled.div`
  background: ${({ $bg }) => $bg};
  border-left: 4px solid ${({ $border }) => $border};
  padding: 1rem 1.25rem;
  border-radius: 0 8px 8px 0;
  margin-bottom: 1rem;
  color: ${colors.textPrimary};

  strong {
    display: block;
    margin-bottom: 0.35rem;
  }

  p {
    margin: 0;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.92);
  }
`;

export default function SupportAlertBanner({ banners }) {
  const { t, i18n } = useTranslation();
  const locale = i18n.language;

  if (!banners) return null;

  const items = [
    { key: 'maintenance', config: banners.maintenance, titleKey: 'publicPages.banners.maintenanceTitle' },
    { key: 'incident', config: banners.incident, titleKey: 'publicPages.banners.incidentTitle' }
  ].filter(({ config }) => config?.enabled && pickLocaleText(config.messages, locale));

  if (!items.length) return null;

  return (
    <>
      {items.map(({ key, config, titleKey }) => {
        const style = severityStyles[config.severity] || severityStyles.info;
        return (
          <Banner key={key} $bg={style.bg} $border={style.border} role="alert">
            <strong>
              {t(titleKey)} — {t(style.labelKey)}
            </strong>
            <p>{pickLocaleText(config.messages, locale)}</p>
          </Banner>
        );
      })}
    </>
  );
}
